import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import LinearProgress from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/LinearProgress';
import { useRefreshAccountsContext } from 'Views/Onboarding/Contexts/RefreshAccountsContext';
import { STATUS_MAP } from 'Views/Onboarding/Pages/Survey/SurveyContentBody/RefreshAccountsIndicator/useRefreshIndicator';

const TRANSITION_DURATION = 1000;

const styles = theme => ({
  root: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    zIndex: theme.zIndex.modal,
  },
  linearProgress: {
    width: '100%',
    backgroundColor: theme.palette.facet.clear,
    transition: theme.transitions.create(['opacity'], {
      duration: TRANSITION_DURATION,
    }),
    opacity: 1,
    pointerEvents: 'none',
  },
  linearProgressClear: {
    opacity: 0,
  },
  linearProgressHidden: {
    display: 'none',
  },
});

const RefreshAccountsIndicator = ({
  className,
  classes,
}) => {
  const {
    status,
    progress,
  } = useRefreshAccountsContext();

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <LinearProgress
        color={'primaryToAccentBlue'}
        variant="determinate"
        value={progress}
        borderRadius={'none'}
        classes={{
          root: classNames(classes.linearProgress, className, {
            [classes.linearProgressClear]: status === STATUS_MAP.finished,
            [classes.linearProgressHidden]: status === STATUS_MAP.waiting,
          }),
        }}
      />
    </Box>
  );
};

RefreshAccountsIndicator.defaultProps = {
  className: '',
};

RefreshAccountsIndicator.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(RefreshAccountsIndicator);
